import React, { useEffect, useState ,useRef} from "react";
import {
  getRecommendationTableContent,    
  storeIsFetching,
  recommendationTableSelectedRows,
  recommendationTableSelectAllProductList,
  storeTableAllDataLoaded,
  updateRecommendationTableContent,
  updateSkuCountData,
  getAlertsActionReasonAndSnooze,
  getDynamicsColumnData,
  getTriggeredDCDynamicsColumnData,
  recommendationTableContent,
  storeActionTakenInfo
} from "../../actions/index";
import { useDispatch, useSelector } from "react-redux";
import "./new-recommendation.css";
import { css } from '@emotion/react';
import BarLoader from "react-spinners/BarLoader";
import NewRecommendationModal from "./NewRecommendationModal";
import { getCookie, PriceFormatter, getRpcEnabledRetailers, decimalConfigRetailerPriceFormat } from "../../helper";
import cloneDeep from "lodash/cloneDeep";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import $ from "jquery";
import AlertLogModal from "../../components/AlertLogModal";
import DynamicColumnDialog from "../../components/DynamicColumnDialog";
import DynamicColumnDialogDCNew from "../../components/DynamicColumnDialogDCNew";
import NoImageeCompass from '../../containers/Insights/NoImageeCompass.jpg';
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom'; 

const ProductTableDcLocation = () => {
  let dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [tableWidth, setTableWidth] = useState(0);
  const [displayModal, setDisplayModal] = useState(false);
  const [activeRowForModel, setActiveRowForModel] = useState({});
  const [activeStrategy, setActiveStrategy] = useState(null);
  const [showAllStrategy, setShowAllStrategy] = useState(true);
  const [isProductLevel, setIsProductLevel] = useState(false);
  let [displayAlertLogModal, setDisplayAlertLogModal] = useState(false);
  const [alertLogModalDetails, setAlertLogModalDetails] = useState({});
  const [allSkuId, setAllSkuId] = useState([])
  const [allSkuSelected, setAllSkuSelected] = useState(false)
  const [dynamicColumnLog, setDynamicColumnLog] = useState(false)
  const [locationModalDetails, setLocationModalDetails] = useState({});  
  let [displayDynamicDCDialogModal, setDisplayDynamicDCDialogModal] = useState(false);
  const [dcLocationModalDetails, setDcLocationModalDetails] = useState({});  

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  let { selectedGlobalFilters,subproject ,isSnoozeSubProject, selectedRetailerCurrency, selectedCustomerKey, dynamicColumnPrecision, dynamicPriceFormatting, defaultAlertFilterCondition, getDecimalRetailersData} = useSelector((state) => state.globalReducer);
  let {
    recommendationSelectedStrategy,
    selectedStrategies,
    detailsForAllStrategies,
    selectedStrategyDateRange,
    strategyCustomDates,
    selectedFilterCondition
  } = useSelector((state) => state.strategyReducer);

  let { actionedAndActiveData } = useSelector(
    (state) => state.recommendationsReducer
  );
  
  let {
    loadStatus,
    responseData,
    selectedRows,
    sortDirecetion,
    sortedColumn,
    curentIndex,
    selectAllProductList,
    setOfDynamicColumns,
    allSkuIds
  } = useSelector((state) => state.newRecommendationTableData);

  //loader
  let { newRecoSearchText,isExpandTableButtonClicked ,isLoadedAll,isFetchingData} = useSelector(
    (state) => state.newRecommendationTableData
  );
  let alertType = "";
  if(selectedStrategies?.length) {
    if(selectedStrategies && selectedStrategies?.length == 1) {
       let filterArr = actionedAndActiveData?.responseData.filter((actAndActv) => selectedStrategies.find(( strName ) => actAndActv.RECOMMENDATION_NAME === strName));
       alertType = filterArr[0] ? filterArr[0]["DISPLAY_TYPE"] : '';
    } else {
       let filterArr = actionedAndActiveData?.responseData.filter((actAndActv) => selectedStrategies.find(( strName ) => actAndActv.RECOMMENDATION_NAME === strName));
       alertType = filterArr[0] ? filterArr[0]["DEFAULT_TYPE"] : '';
    }
  }
let requestObject= {
  filterValues: selectedGlobalFilters,
  recommendationFilters: selectedStrategies,
  curentIndex: 0,
  selectedTab: recommendationSelectedStrategy ? recommendationSelectedStrategy.selection : 'active',
  searchText: newRecoSearchText,
  sortDirecetion: "desc",
  sortedColumn:  isSnoozeSubProject && recommendationSelectedStrategy && recommendationSelectedStrategy.selection === "actioned" ? ["focusAlertEstimation","estimatedRevenueImpact", "daysSinceLastActioned"] : ["focusAlertEstimation","estimatedRevenueImpact"] ,
  filterName: "",
  defaultType: "DC/Cluster",
  locationName: actionedAndActiveData?.locationName ? actionedAndActiveData?.locationName : '',
  type:alertType,
  selectedDateRange:selectedStrategyDateRange !== 'Default' ? strategyCustomDates : '',
  alertFilterCondition: selectedFilterCondition ? selectedFilterCondition : defaultAlertFilterCondition,
};

const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
      if (ref.current) {
        setSticky(ref.current.getBoundingClientRect().top <= 189);

      }
    };

    useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, []);

  useEffect(() => {
   isSnoozeSubProject && selectedStrategies && selectedStrategies.length && recommendationSelectedStrategy && recommendationSelectedStrategy.selection === "active" && dispatch(getAlertsActionReasonAndSnooze({alertName: selectedStrategies.toString()}))
  }, [selectedStrategies]);

  function handleScrollForTable(e) {
    const bottom  = e.target.scrollHeight - e.target.scrollTop < (e.target.clientHeight+20);
    if(bottom && responseData.productList && responseData.productList.length !== responseData.totalCount){
      if(!isFetchingData && !isLoadedAll){
        dispatch(storeIsFetching(true))
        let requestObject= {
          filterValues: selectedGlobalFilters,
          recommendationFilters: selectedStrategies,
          currentIndex: curentIndex,
          selectedTab: recommendationSelectedStrategy && recommendationSelectedStrategy.selection ? recommendationSelectedStrategy.selection : "active",
          searchText: newRecoSearchText,
          sortDirecetion: sortDirecetion,
          sortedColumn: sortedColumn,
          filterName: "",
          defaultType: "DC/Cluster",
          locationName: actionedAndActiveData?.locationName ? actionedAndActiveData?.locationName : '',
          type:alertType,
          selectedDateRange:selectedStrategyDateRange !== 'Default' ? strategyCustomDates : '',
          alertFilterCondition: selectedFilterCondition ? selectedFilterCondition : defaultAlertFilterCondition,
        };
        dispatch(
          getRecommendationTableContent(requestObject)
        )
          .then((data) => {
            if(data.data){
              if(Object.keys(data.data.responseData).length>0){

                  let tempResponseData = cloneDeep(responseData)
                  data.data.responseData.productList.map(item=>{
                    let productKey = Object.keys(item)
                    tempResponseData.productList.push(item)
                    item[productKey].productdetails.selectedProduct = allSkuId.length >= 10
                    item[productKey].storeList.map(storeItem => {
                      storeItem['locationSelected'] = allSkuId.length >= 10
                    })
                  })
                  tempResponseData.curentIndex = data.data.responseData.curentIndex;
                  dispatch(updateSkuCountData({
                    currentCount:tempResponseData.productList.length,totalCount:tempResponseData.totalCount 
                  }))
                  dispatch(updateRecommendationTableContent({curentIndex:data.data.responseData.curentIndex, responseData:tempResponseData}))
              }
              else{
              dispatch(storeTableAllDataLoaded(true)) 
              }
            }
             dispatch(storeIsFetching(false))  
          })
          .catch((err) => {
            setLoading(true);
          });

      }
    }
  }

  useEffect(() => {
    let width= $('.new-recomm-container').width()
    if(width !== tableWidth){
      if(setOfDynamicColumns && setOfDynamicColumns.length < 4)
      width= width+30;
      setTableWidth(width)
    }
  })

  useEffect(() => {
    setLoading(true);
    dispatch(updateSkuCountData(  {currentCount:0,totalCount:0 }))  
    if (selectedStrategyDateRange) {
    dispatch(
      getRecommendationTableContent(requestObject)
    )
      .then((data) => {   
        setAllSkuSelected(false)   
        setLoading(false);
      })
      .catch((err) => {
        dispatch(recommendationTableContent({loadStatus:'default',dynamicColumns:[], setOfDynamicColumns:[],sortedColumn:[],sortDirecetion:'',curentIndex:'',responseData:{productList:[]}, responseDesc:'', 
            responseType:'',selectedRows:{}, selectAllProductList :[]}));
        setLoading(false);
      });
      dispatch(recommendationTableSelectedRows({}));
      dispatch(recommendationTableSelectAllProductList([]))
    }  
  }, [
    selectedStrategies,
    selectedGlobalFilters,
    newRecoSearchText,
    selectedStrategyDateRange,
    strategyCustomDates,
    selectedFilterCondition
  ]);


  let displayLoader = () => {
    return (
      <div id="strategy_wrapper">
        <div className="container-fluid  default-top loading_wrapper  bg-gray p-5">
          <div className="sweet-loading">
            <BarLoader
              css={override}
              size={150}
              color={"#123abc"}
              height={4}
              width={100}
              loading={loading}
            />
          </div>
        </div>
      </div>
    );
  };


  function displayModalOff() {
    if (displayModal) {
      setDisplayModal(false);
    }
  }
  function setCheckBox(store, type,key) {
    if ( selectedRows.constructor === Object) {
      if(type==='selectAll'){
        if(selectedRows[key] &&  Object.keys(selectedRows[key]).length === store.length){
          return true;
        }
          return false;

      }
      if (selectedRows[store.productId] && selectedRows[store.productId][store.fcNameId]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  function getEstimatedValue(selectedStrategies, store){
    let final={};
    selectedStrategies.forEach(strategy =>{
      final[strategy] = store[`${strategy.toLowerCase().replace(/-/g, '_').replace(/ /g, '_')}_estimated_value`]
    
   })
   return final;
  }

  function handleCheckBoxChange(event, productDetails, store, type, selectionType, skus) {
    skus = selectionType == 'allSku' ? skus : getCookie("selected-sku-id") ? getCookie("selected-sku-id") : []
    let tempSelectedRows = cloneDeep(selectedRows);
    let tempSelectAllProductList = [...selectAllProductList]
    let rows = {}
    if(store.length > 0) {
      productDetails.selectedProduct = event.target.checked && type === 'selectAll'
      if(event.target.checked && type === 'selectAll' && selectionType === 'allLocation') {
        skus.push(productDetails.productId)
        setAllSkuId(skus)
        storeSelectedSkuId(skus)
        setAllSkuSelected(allSkuIds.length === skus.length)
        delete tempSelectedRows[productDetails.productId]
      } else if(!event.target.checked && type === 'selectAll' && selectionType === 'allLocation') {
        skus = skus.filter(id => id != productDetails.productId)
        setAllSkuId(skus)
        storeSelectedSkuId(skus)
        setAllSkuSelected(allSkuIds.length === skus.length)
        delete tempSelectedRows[productDetails.productId]
      }
      store.map(storeItem => {
        storeItem.locationSelected = event.target.checked
        tempSelectAllProductList.push(storeItem.productId)
      })
      dispatch({
        type: "SELECTED_SKU_IDS",
        payload: skus
      })
    }else {
      let rows = {}
      let locationCount = 0
      if(event.target.checked) {
        let data = {
          location: store.fcNameId,
          product_id: store.productId,
          upc: store.asin,
          oldInfo: store.actionTakenInfo,
          dateOfRecommendation:store.dateOfRecommendation,
          estimatedVal: getEstimatedValue(selectedStrategies, store),
          dcIdCount:store.dcIdCount 
        };
        rows[store.fcNameId] = data;

        let filteredProduct = responseData.productList.filter(product1 => Object.keys(product1)[0] === productDetails.productId)
        if(filteredProduct && filteredProduct.length) {
          filteredProduct.forEach(prod => {
            prod[productDetails.productId].storeList.forEach(storeItem => {
              if(storeItem.locationSelected) {
                let data = {
                  location:storeItem.fcNameId,
                  product_id:storeItem.productId,
                  upc:storeItem.asin,
                  oldInfo:storeItem.actionTakenInfo,
                  dateOfRecommendation:storeItem.dateOfRecommendation,
                  estimatedVal: getEstimatedValue(selectedStrategies,storeItem),
                  dcIdCount:storeItem.dcIdCount
                };
                rows[storeItem.fcNameId] = data
              }
              if(storeItem.fcNameId !== store.fcNameId && !storeItem.locationSelected)
                locationCount++
            })
            productDetails.selectedProduct = locationCount >= 1 ? false : true
            if(locationCount >= 1) {
              tempSelectedRows[productDetails.productId] = rows              
            }else {
              delete tempSelectedRows[store.productId]
              skus.push(productDetails.productId)
              setAllSkuId(skus)
              storeSelectedSkuId(skus)
              setAllSkuSelected(allSkuIds.length === skus.length)
              dispatch({
                type: "SELECTED_SKU_IDS",
                payload: skus
              })
            }
          })
        }
      }else {
        let rows = {}
        productDetails.selectedProduct = false
        let filteredProduct = responseData.productList.filter(product1 => Object.keys(product1)[0] === productDetails.productId)
        if(filteredProduct && filteredProduct.length) {
          filteredProduct.forEach(prod => {
            prod[productDetails.productId].storeList.forEach(storeItem => {
              if(storeItem.locationSelected && storeItem.fcNameId !== store.fcNameId) {
                let data = {
                  location:storeItem.fcNameId,
                  product_id:storeItem.productId,
                  upc:storeItem.asin,
                  oldInfo:storeItem.actionTakenInfo,
                  dateOfRecommendation:storeItem.dateOfRecommendation,
                  estimatedVal: getEstimatedValue(selectedStrategies, storeItem),
                  dcIdCount:storeItem.dcIdCount
                };
                rows[storeItem.fcNameId] = data
              }
            })
          })
        }
        if(Object.keys(rows).length){
          tempSelectedRows[productDetails.productId] = rows
        }else
          delete tempSelectedRows[productDetails.productId]
        skus = skus.filter(id => id != productDetails.productId)
        setAllSkuId(skus)
        storeSelectedSkuId(skus)
        setAllSkuSelected(false)
        dispatch({
          type: "SELECTED_SKU_IDS",
          payload: skus
        })
      }
      store.locationSelected = event.target.checked
      tempSelectAllProductList.push(store.productId)
    }
    if(!event.target.checked && tempSelectAllProductList && tempSelectAllProductList.length) {
      tempSelectAllProductList = tempSelectAllProductList.filter(id => id != productDetails.productId)
    }
    tempSelectAllProductList = tempSelectAllProductList.filter((value, index) => tempSelectAllProductList.indexOf(value) === index)
    dispatch(recommendationTableSelectedRows(tempSelectedRows))
    dispatch(recommendationTableSelectAllProductList(Object.keys(tempSelectedRows).length <= 0 && skus.length <=0 ? [] : tempSelectAllProductList))
  }

  function storeSelectedSkuId(skus) {
    document.cookie = `selected-sku-id=${JSON.stringify(skus)};path=/;max-age=3600`
  }

  function reorderColumnData(columnName){
    let direction = 'asc';
      if(sortedColumn && (sortedColumn.indexOf(columnName) > -1 )){
        if(sortDirecetion==='asc'){
          direction='desc'
        }
        else if(sortDirecetion==='desc'){
          direction='asc'
        }

      }
      let requestObject= {
        filterValues: selectedGlobalFilters,
        recommendationFilters: selectedStrategies,
        curentIndex: 0,
        selectedTab: recommendationSelectedStrategy ? recommendationSelectedStrategy.selection : 'active',
        searchText: newRecoSearchText,
        sortDirecetion: direction,
        sortedColumn: [columnName],
        filterName: "",
        locationName: actionedAndActiveData?.locationName ? actionedAndActiveData?.locationName : '',
        defaultType: "DC/Cluster",
        type: alertType,
        selectedDateRange:selectedStrategyDateRange !== 'Default' ? strategyCustomDates : '',
        alertFilterCondition: selectedFilterCondition ? selectedFilterCondition : defaultAlertFilterCondition,
      };
      dispatch(
        getRecommendationTableContent(requestObject)
      )
        .then((data) => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(true);
        });


  }
  function renderSortDirection(columnName){
    if(sortedColumn && (sortedColumn.indexOf(columnName) > -1 )){

        if(sortDirecetion==='asc'){
          return(<i className="fas fa-sort-up  default-sort-icon active"></i>)
        }
        else if(sortDirecetion==='desc'){
            return(<i className="fas fa-sort-down  default-sort-icon active"></i>)
        }

    }
    else{
      return(<i className="fas fa-sort default-sort-icon"></i>)
    }

  }
  function renderStrategiesModelWindow() {
    if (displayModal) {
      let user_info = localStorage.getItem("user-info");
      let reportId = "";
      detailsForAllStrategies.map((strategy, index) => {
        if (
          strategy.strategyName.toLowerCase() ===
          activeStrategy.recommendationName.toLowerCase()
        ) {
          reportId = strategy.strategyReportId;
        }
      });
      return (
        <NewRecommendationModal
          asin={activeRowForModel["asin"]}
          recommendationName={activeStrategy["recommendationName"]}
          chosenProductId={activeRowForModel["productId"]}
          chosenLocation={activeRowForModel["location"]}
          chosenSource={activeRowForModel.channel}
          reportId={reportId}
          chosenKcCategory={activeRowForModel["kcPlatform"]}
          chosenCustomerKey={selectedCustomerKey}
          user={JSON.parse(user_info).email}
          displayModalOff={displayModalOff}
          listOfStrategiesInfo={activeRowForModel["recommendationInfo"]}
          activeRowForModel = {activeRowForModel}
        />
      );
    }
  }
  
  function renderDynamicColumnValues(store){
    if(setOfDynamicColumns && setOfDynamicColumns.length>0){
      return setOfDynamicColumns.map((col,index)=>{        
        let tempVal = store[col.Metric_Display_Value];
        let tempType = (col.Type).toLowerCase();
        let alertName =  col.Strategy.toLowerCase().replace(/ /g,"_");     
        let metricName = col.Metric_name.toLowerCase().trim(); 
        if((dynamicPriceFormatting && dynamicPriceFormatting === 'dot') && tempVal) {
          if(tempType ==='dollar'){
            tempVal = decimalConfigRetailerPriceFormat(tempVal,selectedRetailerCurrency);
          }
          else if(tempType ==='double'){ 
            tempVal = PriceFormatter((tempVal),  {precision: 2, symbol:''}).replace(/(\.|,)/g, (x)=> {
              return x == ',' ? '.' :  x == '.' ? ',' : '';});
          }
          else if(tempType==='percentage'){
            tempVal = PriceFormatter((tempVal),  {precision: 2, symbol:'%', format:'%v %s' }).replace(/(\.|,)/g, (x)=> {
              return x == ',' ? '.' :  x == '.' ? ',' : '';})
          }
        }else if(dynamicColumnPrecision && dynamicColumnPrecision[alertName] && (dynamicColumnPrecision[alertName][metricName] || dynamicColumnPrecision[alertName][metricName] === 0)) {                
          if(tempType==='dollar'){
            tempVal = PriceFormatter(tempVal, { precision: getDecimalRetailersData?.DECIMAL_PRECISION, symbol : selectedRetailerCurrency})
          }
          else if(tempType==='percentage'){
            tempVal = PriceFormatter((tempVal),  {precision: dynamicColumnPrecision[alertName][metricName], symbol:'%', format:'%v %s' })
          }
          else {
            tempVal = PriceFormatter((tempVal),  {precision: dynamicColumnPrecision[alertName][metricName], symbol:'' })
          }   
        }else{     
          if(tempType==='dollar'){
            tempVal = PriceFormatter(tempVal, { precision: getDecimalRetailersData?.DECIMAL_PRECISION, symbol : selectedRetailerCurrency})
          }
          else if(tempType==='double'){
            tempVal = PriceFormatter(tempVal, { precision: 2,symbol:'' })
          }
          else if(tempType==='percentage'){
            tempVal = PriceFormatter((tempVal),  {precision: 1, symbol:'%', format:'%v %s' })
          }
        }
        return(
          <div className="recomm-col txt-right-aligned">
              {tempVal}
          </div>
        )
                
      })
    }
  }

  let responseHandler = (response) => { 
    if(response.data.responseData?.allLocationIds.length === 0 && response.data.responseData?.productList.length === 0) {
      dispatch(storeActionTakenInfo(true));
      setLoading(true);
      toast.warning("Some of the alerts have been updated by another user already; hence the page has been refreshed with the latest status.", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 15000,
        className:'toastwarning-cls',
      });
      setLoading(false);
      dispatch(storeActionTakenInfo(false));
    } else {
      setDynamicColumnLog(true);
    }
    
  }

  let dcResponseHandler = (response) => {    
    setDisplayDynamicDCDialogModal(true);
  }

  

  function showAllDCTriggeredLocation(productDetails) {
      dispatch(
        getTriggeredDCDynamicsColumnData({
           recommendationFilters: selectedStrategies,
           productId: productDetails.productId,
           dcIdCount:"",
           dcId: "",
           currentIndex:0,
           filterValues: selectedGlobalFilters,
           selectedTab: recommendationSelectedStrategy && recommendationSelectedStrategy.selection ? recommendationSelectedStrategy.selection : "active",
           searchText: newRecoSearchText,
           sortDirecetion: "desc",
           sortedColumn: isSnoozeSubProject && recommendationSelectedStrategy && recommendationSelectedStrategy.selection === "actioned" ? ["focusAlertEstimation","estimatedRevenueImpact", "daysSinceLastActioned"] : ["focusAlertEstimation","estimatedRevenueImpact"] ,
           filterName: "",
           alertInFocus: recommendationSelectedStrategy.strategyName,
           type: "",
           viewType: 'all',
           selectedDateRange:selectedStrategyDateRange !== 'Default' ? strategyCustomDates : '',
           alertFilterCondition: selectedFilterCondition ? selectedFilterCondition : defaultAlertFilterCondition,
        }, dcResponseHandler)
       )
      setDcLocationModalDetails(productDetails);
  }

  function showDynamicColDialog (store) {
    let alertType = "";
    if(selectedStrategies?.length){
      if(selectedStrategies && selectedStrategies?.length == 1) {
        let filterArr = actionedAndActiveData?.responseData.filter((actAndActv) => selectedStrategies.find(( strName ) => actAndActv.RECOMMENDATION_NAME === strName));
        alertType = filterArr[0]["DISPLAY_TYPE"];
      } else {
        let filterArr = actionedAndActiveData?.responseData.filter((actAndActv) => selectedStrategies.find(( strName ) => actAndActv.RECOMMENDATION_NAME === strName));
        alertType = filterArr[0]["DEFAULT_TYPE"];
      }
    }
    var triggerlocation = JSON.parse(localStorage.getItem('triggerlocation'));
    let selectedStrategy = selectedStrategies?.length && selectedStrategies[0];  
    let dcproductId = triggerlocation?.dcproductId,dclocationName = triggerlocation?.dclocationName,
    selectedStrategyName = triggerlocation?.selectedStrategyName, dclocationCount = triggerlocation?.dclocationCount
    let currentPath = location.pathname;
    let currentPathArr = subproject.toLowerCase();
    let currentUrl = currentPathArr +'/alerts';
    let currentAlertspage = currentPath.substring(currentPath.indexOf(currentPathArr));
    if(currentAlertspage === currentUrl && selectedStrategy === selectedStrategyName && dcproductId === store.productId && dclocationName === store.fcNameId && dclocationCount ===  store.dcIdCount) {
      setLoading(true);
      dispatch(storeActionTakenInfo(true));     
      toast.warning("Some of the alerts have been updated by another user already; hence the page has been refreshed with the latest status.", {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 15000,
        className:'toastwarning-cls',
      });
      const wrn = () => {
        setLoading(false);
        dispatch(storeActionTakenInfo(false));
        localStorage.removeItem("triggerlocation");  
      };
      setTimeout(wrn, 1000);
    } else {
      dispatch(
        getDynamicsColumnData({
          recommendationFilters: selectedStrategies,
          productId: store.productId,
          dcIdCount: store.dcIdCount,
          dcId: store.fcNameId,
          currentIndex:0,
          filterValues: selectedGlobalFilters,
          selectedTab: recommendationSelectedStrategy && recommendationSelectedStrategy.selection ? recommendationSelectedStrategy.selection : "active",
          searchText: newRecoSearchText,
          sortDirecetion: "desc",
          sortedColumn: isSnoozeSubProject && recommendationSelectedStrategy && recommendationSelectedStrategy.selection === "actioned" ? ["focusAlertEstimation","estimatedRevenueImpact", "daysSinceLastActioned"] : ["focusAlertEstimation","estimatedRevenueImpact"] ,
          filterName: "",
          alertInFocus: recommendationSelectedStrategy.strategyName,
          type: alertType,
          selectedDateRange:selectedStrategyDateRange !== 'Default' ? strategyCustomDates : '',
          alertFilterCondition: selectedFilterCondition ? selectedFilterCondition : defaultAlertFilterCondition,
        }, responseHandler)
      )    
    setLocationModalDetails(store);
    }
  }

  function renderStoreList(storeList,productDetails) {
    if (storeList.length > 0) {
      return storeList.map((store) => {
        let tempClassForLocationRow = "locations";
        if (setCheckBox(store)) {
          tempClassForLocationRow = "locations active";
        }
        return (
          <div className={tempClassForLocationRow}>
            <div className="recomm-col location_block">
              <div className="form-check form-check-custom">
                <input
                  className="form-check-input custom"
                  type="checkbox" disabled={!selectedStrategies?.length}
                  checked={store.locationSelected}
                  onChange={(event) => handleCheckBoxChange(event, productDetails, store,'single', 'location')}
                />
               {!selectedStrategies?.length ? (
                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltiplink-disabled">Please select an alert to see the triggered locations </Tooltip>}>
                    <i class="" style={{ fontSize:14,fontStyle:"normal",color:"#1563ff"}}> {store.fcNameId} ({store?.dcIdCount === 0 ? 1 : store?.dcIdCount} of {store?.totalLocationCount ? store?.totalLocationCount : store?.dcIdCount === 0 ? 1 : store?.dcIdCount})</i>
                  </OverlayTrigger>
                  ) : <label className="form-check-label" for="all" onClick={() => showDynamicColDialog(store)} style={{color:"#1563ff",cursor: "pointer"}}>
                  {store.fcNameId} ({store?.dcIdCount === 0 ? 1 : store?.dcIdCount} of {store?.totalLocationCount ? store?.totalLocationCount : store?.dcIdCount === 0 ? 1 : store?.dcIdCount})
                </label>}
                
              </div>
            </div>
            {recommendationSelectedStrategy &&  recommendationSelectedStrategy.activeRowDetails ?
              <div className="recomm-col txt-right-aligned">
                {(dynamicPriceFormatting && dynamicPriceFormatting === 'dot') && store.focusAlertEstimation ? 
                decimalConfigRetailerPriceFormat(store.focusAlertEstimation,selectedRetailerCurrency):
                PriceFormatter(store.focusAlertEstimation, { precision: getDecimalRetailersData?.DECIMAL_PRECISION, symbol: selectedRetailerCurrency})}
                </div> : null }               
            
            <div className="recomm-col txt-right-aligned">{(dynamicPriceFormatting && dynamicPriceFormatting === 'dot') && store.estimatedRevenueImpact ? 
                decimalConfigRetailerPriceFormat(store.estimatedRevenueImpact,selectedRetailerCurrency):
                PriceFormatter(store.estimatedRevenueImpact, { precision:getDecimalRetailersData?.DECIMAL_PRECISION, symbol: selectedRetailerCurrency})}</div>
            
            {renderDynamicColumnValues(store)}           
          
          </div>
        );
      });
    }
  }
  
  function renderProductLinks(productDetails) {
    if (productDetails.links.length > 0) {
      return productDetails.links.map((item) => {
        return (
          <li>
            <a href={item.hrefLink} target="_blank">
              {item.text}
            </a>
          </li>
        );
      });
    }
  }
  function renderEmptyColumns(){
    if(setOfDynamicColumns && setOfDynamicColumns.length>0){
      return setOfDynamicColumns.map((col,index)=>{
          return(<div className="recomm-col"></div>)
      })
    }
  }
  function renderFetchingMoreItems(){
    if(isFetchingData && !isLoadedAll){
    return(<div className='fetchingMoreItem'>
        <img src={require('./loadmore.gif')} className='fetechMoreImg' />
        Fetching more products...
    </div>)
    }
  }
 
  function updateProduct(event, productDetails) {
    productDetails['selectedProduct'] = event.target.checked
    delete selectedRows[productDetails.productId]
    dispatch(recommendationTableSelectedRows(selectedRows))
    let skus = getCookie("selected-sku-id") ? getCookie("selected-sku-id") : []
    if(event.target.checked) {
      skus.push(productDetails.productId)
      setAllSkuId(skus)
      storeSelectedSkuId(skus)
      setAllSkuSelected(allSkuIds.length === skus.length)
    }else{
      skus = skus.filter(id => id != productDetails.productId)
      setAllSkuId(skus)
      storeSelectedSkuId(skus)
      setAllSkuSelected(false)
    }
    dispatch({
      type: "SELECTED_SKU_IDS",
      payload: skus
    })
  }

  function updateAllSKU(event) {
    let skus = event.target.checked ? allSkuIds : []
    selectedRows = {}
    dispatch(recommendationTableSelectedRows({}))
    setAllSkuId(skus)
    storeSelectedSkuId(skus)
    dispatch({
      type: "SELECTED_SKU_IDS",
      payload: skus
    })
    setAllSkuSelected(event.target.checked)
    responseData.productList.map(product => {
      Object.keys(product).map(key => {
        product[key]['productdetails']['selectedProduct'] = event.target.checked
        handleCheckBoxChange(event, product[key]['productdetails'], product[key]['storeList'], 'selectAll', 'allSku', skus)
      })
    })
  }


  function renderRecommmendationTableRows() {    
    if (loadStatus && loadStatus === "loaded") {
      return  responseData && responseData.productList && responseData.productList.map((product) => {
        return Object.keys(product).map((key) => {
          let productDetails = product[key]["productdetails"];
          let productnamesubsring = productDetails.name ? productDetails.name.substring(0,105) : "";
          let recomproductImage = productDetails?.imagelink ? productDetails.imagelink : NoImageeCompass;
          return (
            <div className={`recomm-row ${setOfDynamicColumns?.length <= 2 ? "recomm-dynamiccoldc":""}`}>
              {/* First Column - product Column */}
                <div className="recomm-product">
                  <div className="product-box">
                    <input className="product_imagecheck" 
                           type="checkbox" disabled={!selectedStrategies?.length}
                           checked={productDetails.selectedProduct}
                           onChange={(e) => {
                             updateProduct(e, productDetails)
                             handleCheckBoxChange(e, productDetails, product[key]['storeList'],'selectAll','sku');
                           }}
                     />
                    <div className="product">
                        <img
                          src={recomproductImage}
                          className="product-img"
                        />
                      </div>
                      <div className='product-sku'>
                          <div style={{paddingRight:"6px"}}><div><b>Product ID </b></div>{productDetails.productId}</div>
                          {getRpcEnabledRetailers().includes(subproject) && 
                          <div style={{paddingRight:"6px"}}><div><b>RPC </b> </div>{productDetails?.rpc ? productDetails.rpc : 'N/A'}</div> 
                          }
                          <div><div><b>UPC </b> </div>{productDetails.upc}</div>
                      </div>
                      <div className="product-name">
                      
                      {productDetails.name && productDetails.name.length > 105 ? (<OverlayTrigger placement="right" overlay={<Tooltip id="tooltipproduct-disabled">{productDetails.name}</Tooltip>}>
                      <i className="productdetail-name">{productnamesubsring}...</i>
                    </OverlayTrigger>) : productDetails.name}
                    </div>
                    <div className="product-Desc">{ productDetails.desc}</div>
                      <div className="product-Links">
                        <ul>{renderProductLinks(productDetails)}</ul>
                      </div>
                  </div>
                </div>
              {/* Recomm stores*/}

              <div className={`recomm-locations recomm-locations-overflow ${setOfDynamicColumns?.length <= 2 ? "recomm-dynamiccoldc" : ""}`}>
                <div className="locations">
                  <div className="recomm-col location_block">
                    <div className="form-check form-check-custom">
                      <input
                        className="form-check-input custom"
                        type="checkbox" disabled={!selectedStrategies?.length}
                        checked = {productDetails.selectedProduct}
                        onChange={(event)=>handleCheckBoxChange(event, productDetails, product[key]['storeList'],'selectAll', 'allLocation')}
                      />
                      <label className="form-check-label" for="all">
                      Select All Locations
                      {alertType === 'DC/Cluster' && <span  onClick={() => showAllDCTriggeredLocation(productDetails)} style={{color:"#1563ff",cursor: "pointer"}}> | Show all triggered locations</span> }
                      </label>
                    </div>
                  </div>
                  {recommendationSelectedStrategy && recommendationSelectedStrategy.activeRowDetails &&
                  <div className="recomm-col"></div> }
                 
                 <div className="recomm-col"></div>
                 
                  {renderEmptyColumns()}
                </div>
                {renderStoreList(product[key]["storeList"],productDetails)}
              </div>

              {/* Recomm stores end*/}
            </div>
          );
        });
      });
    }
  }

 !isExpandTableButtonClicked  && $(function(){
  $(".wrapper1").scroll(function(){     
      $(".wrapper2")
          .scrollLeft($(".wrapper1").scrollLeft());
  });
  $(".wrapper2").scroll(function(){
      $(".wrapper1")
          .scrollLeft($(".wrapper2").scrollLeft());
  });
});
 function renderTableHeaderColumns(){
   if(setOfDynamicColumns && setOfDynamicColumns.length>0){
     return setOfDynamicColumns.map((col,index)=>{
       return(
         <div  onClick={(e)=>reorderColumnData(col.Metric_Display_Value)}>
           <div className="col-title" >
             {col.Display_name}{" "}
             {renderSortDirection(col.Metric_Display_Value)}
           </div>
         </div>
       )
     })
   }
 }


let toggleAlertLogModal = () =>{
  let toggle =displayAlertLogModal
  setDisplayAlertLogModal(!toggle)
}
let toggleDynamicColumnLogModal = () =>{
  let flag =dynamicColumnLog
  setDynamicColumnLog(!flag)
}

let toggleDynamicDCColumnLogModal  = () => {
  let flag =displayDynamicDCDialogModal
  setDisplayDynamicDCDialogModal(!flag)
}

  if (loading) return displayLoader();
  else if (responseData.productList && responseData.productList.length<=0)
  return (<div id="no-data-available">No products available to display</div>)
  else if ((newRecoSearchText || (selectedStrategies && selectedStrategies?.length) || (recommendationSelectedStrategy && Object.keys(recommendationSelectedStrategy) && Object.keys(recommendationSelectedStrategy).length)) && responseData.productList && responseData.productList.length>0)
    return (
      <div className={isExpandTableButtonClicked ? "full-screen-mode-table-row" : "row"} >
          {displayAlertLogModal ?  <AlertLogModal displayAlertLogModalOff={toggleAlertLogModal} displayAlertLogModal={displayAlertLogModal}  isProductLevel={isProductLevel} alertLogModalDetails= {alertLogModalDetails}/>  : null }
          { dynamicColumnLog ?  <DynamicColumnDialog 
                  dynamicColumnLog={dynamicColumnLog} 
                  displayColumnDialogOff={toggleDynamicColumnLogModal} 
                  locationModalDetails={locationModalDetails}  
                  columns={setOfDynamicColumns} 
                  data={setOfDynamicColumns} />  
              : null }
          { displayDynamicDCDialogModal ?  <DynamicColumnDialogDCNew 
                  dynamicColumnLog={ displayDynamicDCDialogModal }  
                  displayDynamicColumnDialogOff={toggleDynamicDCColumnLogModal} 
                  dcLocationModalDetails={dcLocationModalDetails} />  
             : null }
      
        <div className="col-12" >
          {/* Custom code for  product table*/}
          <div style={{display:"flex",width:"100%",paddingTop:"4px"}}>
          <div className={setOfDynamicColumns && setOfDynamicColumns.length <= 2 ? "form-check form-check-custom recom_horizontal recomm-dynamiccoldc" : "form-check form-check-custom recom_horizontal"} >
                      <input className="form-check-input custom" type="checkbox" checked={allSkuSelected} disabled={!selectedStrategies?.length}  onChange={(e) => {
                             updateAllSKU(e);
                           }}/>
                      <label className="form-check-label" for="all" style={{paddingLeft:6,position:"relative",bottom:"1px"}} >
                        Select All {responseData.totalCount} SKU(s)
                      </label>
                    </div>
         {!isExpandTableButtonClicked && <div
            className={`wrapper1 new-recomm sticky-wrapper ${setOfDynamicColumns && setOfDynamicColumns.length < 2 && !isSnoozeSubProject ? "width-auto" : ""}`}
            ref={ref}
            id="sticky"
            style={{backgroundColor:"white",height:10, overflowY:"auto",marginTop:"8px"}}
          >
            <div style={{width: tableWidth , height:16}}>  </div>
          </div> } 
          </div>
          <div className={`table-responsive wrapper2 new-recomm sticky-wrapper ${isExpandTableButtonClicked ? "full-screen-mode-table" : ""} ${isSticky ? ' sticky' : ''} ${setOfDynamicColumns && setOfDynamicColumns.length<2 && !isSnoozeSubProject?'width-auto':''}`} ref={ref} id='sticky' onScroll={(e)=>{handleScrollForTable(e)}} style={{backgroundColor:"white"}}>
            <div className="new-recomm-container">
              <div className={`recomm-header ${setOfDynamicColumns?.length <= 2 ? "recomm-dynamiccoldc" : ""}`} >
                <div className="headcol first-col">Product</div>
                <div className="headcol location_block" onClick={(e)=>reorderColumnData('fcNameId')}>
                  <div>
                    Locations triggered
                   {renderSortDirection('fcNameId')}
                  </div>
                </div>
                {recommendationSelectedStrategy &&  recommendationSelectedStrategy.activeRowDetails ?
                  <div onClick={(e)=>reorderColumnData('focusAlertEstimation')}>
                      <div className="col-title" >
                        Focus Alert<br/> Estimated Value{renderSortDirection('focusAlertEstimation')}
                      </div>
                  </div> : null }
                {/* hard code for snooze */}
                {/* {isSnoozeSubProject && renderSnoozeRelatedColumnsHeader()} */}
                <div onClick={(e)=>reorderColumnData('estimatedRevenueImpact')}>
                   
                  <div className="col-title"  >
                    Total Estimated Value
                    {renderSortDirection('estimatedRevenueImpact')}
                  </div>
                </div>
                
                {/* {renderStrategiesHeader()} */}  
               {renderTableHeaderColumns()}
               {/* <div><div className="col-title">Location details</div></div> */}
              </div>
              <div className="recomm-body">
                {renderRecommmendationTableRows()}
              </div>
            </div>

          {renderFetchingMoreItems()}
          </div>
          {/* Custom code for  product table* ends */}
        </div>
        {renderStrategiesModelWindow()}
      </div>
    );
    else
    return(<div id="no-data-available">No products available to display</div>)
};

export default ProductTableDcLocation;
